import moment from "moment";

export const formatDateForServer: (momentInstance: moment.Moment) => string = (
  momentInstance
) => {
  return moment(momentInstance).format("YYYY-MM-DD");
};

export const humanizeNumbers: (
  number: number,
  hideDecimal?: boolean,
  compact?: boolean,
  decimalPlaces?: number
) => string = (number, hideDecimal, compact, decimalPlaces = 2) => {
  let divisor: number = 1;
  let identifier: string = "";
  if (number >= 1_000 && number < 1_00_000) {
    divisor = 1_000;
    identifier = "K";
  } else if (number >= 1_00_000 && number < 1_00_00_000) {
    divisor = 1_00_000;
    identifier = "L";
  } else if (number >= 1_00_00_000) {
    divisor = 1_00_00_000;
    identifier = "Cr";
  }

  const _n = compact ? number / divisor : number;
  const suffix = compact ? " " + identifier : "";
  const maximumFractionDigits = hideDecimal ? 0 : decimalPlaces;

  return Number(_n).toLocaleString("en-IN", { maximumFractionDigits }) + suffix;
};

export const replaceAll = (str: string, find: string, replace: string) =>
  str.replace(new RegExp(find, "g"), replace);

// Function to split name into components
export const splitName = (fullName: string) => {
  // Handle null, undefined, or empty string
  if (!fullName?.trim()) {
    return { first_name: "", middle_name: "", last_name: "" };
  }

  // Remove special characters and extra spaces, only allow letters
  const sanitizedName = fullName
    .replace(/[^a-zA-Z\u00C0-\u017F\s]/g, "") // Keep only letters and spaces
    .replace(/\s+/g, " ") // Replace multiple spaces with single space
    .trim();

  // Handle case where name is empty after sanitization
  if (!sanitizedName) {
    return { first_name: "", middle_name: "", last_name: "" };
  }

  // Split name and handle capitalization
  const [first, ...rest] = sanitizedName.split(/\s+/);
  const last = rest.pop() || "";

  // Capitalize each part
  const capitalize = (str: string) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  return {
    first_name: capitalize(first || ""),
    middle_name: rest.map(capitalize).join(" "),
    last_name: capitalize(last),
  };
};
